import React from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import request from '../../../../../utils/request';
import { EditContainer, DeleteMessage } from '../css';

const Delete = ({ id, name, mode, setMode, fetchData }) => {
  const removeDomain = async () => {
    try {
      const result = await request.delete(`/domains/${id}`);

      if (result && result.status === 200) {
        setMode({ ...mode, delete: false });
        fetchData();
      }
    } catch (err) {
      setMode({ ...mode, delete: false });
      throw err;
    }
  };

  return (
    <EditContainer>
      <DeleteMessage>Are you sure you want to remove {name}?</DeleteMessage>
      <Button type="button" onClick={removeDomain}>
        Confirm
      </Button>
      <Button
        variant="secondary"
        type="button"
        onClick={() => setMode({ ...mode, delete: false })}
      >
        Cancel
      </Button>
    </EditContainer>
  );
};

Delete.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  mode: PropTypes.shape({ edit: PropTypes.bool, delete: PropTypes.bool })
    .isRequired,
  setMode: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Delete;
